import React from 'react';
import { Home, Users, User, BarChart2 } from 'lucide-react';
import { Logo } from './Logo';
interface NavbarProps {
  currentPage: 'home' | 'recruiting' | 'reports';
  onNavigate: (page: 'home' | 'recruiting' | 'reports') => void;
}
export function Navbar({
  currentPage,
  onNavigate
}: NavbarProps) {
  return <nav className="bg-white border-b border-gray-200 sticky top-0 z-40" data-id="element-948">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-949">
        <div className="flex justify-between h-16" data-id="element-950">
          <div className="flex" data-id="element-951">
            <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => onNavigate('home')} data-id="element-952">
              <Logo className="h-9 w-auto" data-id="element-953" />
            </div>
            <div className="hidden sm:ml-8 sm:flex sm:space-x-8" data-id="element-954">
              <button onClick={() => onNavigate('home')} className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${currentPage === 'home' ? 'border-orange-500 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-955">
                <Home className="w-4 h-4 mr-2" data-id="element-956" />
                Home
              </button>
              <button onClick={() => onNavigate('recruiting')} className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${currentPage === 'recruiting' ? 'border-orange-500 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-957">
                <Users className="w-4 h-4 mr-2" data-id="element-958" />
                Recruiting
              </button>
              <button onClick={() => onNavigate('reports')} className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${currentPage === 'reports' ? 'border-orange-500 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-959">
                <BarChart2 className="w-4 h-4 mr-2" data-id="element-960" />
                Reports
              </button>
            </div>
          </div>
          <div className="flex items-center" data-id="element-961">
            <div className="flex-shrink-0" data-id="element-962">
              <div className="flex items-center gap-3" data-id="element-963">
                <div className="text-right hidden md:block" data-id="element-964">
                  <p className="text-sm font-medium text-gray-900" data-id="element-965">
                    Sarah Johnson
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-966">HR Director</p>
                </div>
                <div className="h-8 w-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 border border-orange-200" data-id="element-967">
                  <User className="h-5 w-5" data-id="element-968" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sm:hidden border-t border-gray-200" data-id="element-969">
        <div className="flex justify-around p-2" data-id="element-970">
          <button onClick={() => onNavigate('home')} className={`flex flex-col items-center p-2 rounded-md ${currentPage === 'home' ? 'text-orange-600 bg-orange-50' : 'text-gray-500'}`} data-id="element-971">
            <Home className="w-5 h-5" data-id="element-972" />
            <span className="text-xs mt-1" data-id="element-973">Home</span>
          </button>
          <button onClick={() => onNavigate('recruiting')} className={`flex flex-col items-center p-2 rounded-md ${currentPage === 'recruiting' ? 'text-orange-600 bg-orange-50' : 'text-gray-500'}`} data-id="element-974">
            <Users className="w-5 h-5" data-id="element-975" />
            <span className="text-xs mt-1" data-id="element-976">Recruiting</span>
          </button>
          <button onClick={() => onNavigate('reports')} className={`flex flex-col items-center p-2 rounded-md ${currentPage === 'reports' ? 'text-orange-600 bg-orange-50' : 'text-gray-500'}`} data-id="element-977">
            <BarChart2 className="w-5 h-5" data-id="element-978" />
            <span className="text-xs mt-1" data-id="element-979">Reports</span>
          </button>
        </div>
      </div>
    </nav>;
}